import { useOpenableElementIsOpen } from 'src/components/hooks/useOpenableElement';

import useOpenAwaiter from 'src/components/hooks/useOpenAwaiter';

import ChatEnvironmentSettingsDialog, {
  ChatEnvironment,
  ChatEnvironmentSettingsDialogProps,
} from '@/components/organisms/chatEnvironmentSettingsDialog/ChatEnvironmentSettingsDialog';
import ChatThemeProvider from '@/providers/ChatThemeProvider';

const ChatEnvironmentSettingsDialogEx = (
  props: Omit<ChatEnvironmentSettingsDialogProps, 'open'> & {
    isOpenKey: string;
  }
) => {
  const isOpen = useOpenableElementIsOpen(props.isOpenKey);
  return (
    <ChatThemeProvider>
      <ChatEnvironmentSettingsDialog open={isOpen} {...props} />
    </ChatThemeProvider>
  );
};

const useChatEnvironmentSettingsDialog = () => {
  const openAwaiter = useOpenAwaiter<ChatEnvironment | undefined>();
  return {
    open: (
      props: Omit<ChatEnvironmentSettingsDialogProps, 'open' | 'onClose'>
    ) =>
      openAwaiter.open(
        <ChatEnvironmentSettingsDialogEx
          isOpenKey={openAwaiter.key}
          onClose={openAwaiter.close}
          {...props}
        />
      ),
  };
};
export default useChatEnvironmentSettingsDialog;
